import { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';

import { Flex, Input } from '@opendoor/bricks/core';

import { CurrencyQuestion } from 'src/lib/flow/FlowQuestion';
import { changeAnswers } from 'src/store/sellerInput';

import { trackAnswerChange } from './trackAnswerChange';

type CurrencyInputProps = {
  question: CurrencyQuestion;
  value?: string;
};

const CurrencyInput: React.FC<CurrencyInputProps> = ({ question, value }) => {
  const dispatch = useDispatch();
  const { key, placeholder, label } = question;

  const onChange = (_event: ChangeEvent<HTMLInputElement>, newValue: string | undefined) => {
    const answer = newValue?.trim() ? parseFloat(newValue.trim()) : null;

    dispatch(changeAnswers([{ key, answer }]));
    trackAnswerChange(key, newValue ?? undefined);
  };

  return (
    <Flex flexDirection="column">
      <Input
        analyticsName={`reception-fe-question-currency`}
        type="currency"
        id={key}
        label={label}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        name={key}
        //unboundedWidth={unboundedWidth}
      />
    </Flex>
  );
};

export default CurrencyInput;
